import _ from "lodash";
import api from "@/api/cloud";

export default {
	namespaced: false,

	getters: {
		nodeByGuidProvision: (state, getters, rootState) => guid =>
			_.find(rootState.devices.items, { guid }),
	},

	actions: {
		async addProvision(
			{ commit, rootState },
			{ name, parent, description, subpath = null }
		) {
			const rootNode = rootState.devices.rootNode.guid;
			const parentNode = parent || rootNode;
			const systemId = rootState.session.systemId;
			const cls = _.get(description, "meta.cls", null);
			const devices = await api.addDevice(
				name,
				parentNode,
				subpath,
				cls,
				systemId
			);
			commit("devices/setDevices", devices, { root: true });
		},

		async removeProvision({ commit, rootState }, { node }) {
			const systemId = rootState.session.systemId;
			await api.removeDevice(node, systemId);
			commit("devices/removeDevice", node.guid, { root: true });
		},

		async renameProvision({ commit, rootState }, { node, name }) {
			const systemId = rootState.session.systemId;
			const devices = await api.renameDevice(node, name, systemId);
			commit("devices/setDevices", devices, { root: true });
		},

		async moveProvision({ commit, rootState }, { node, destination }) {
			const systemId = rootState.session.systemId;
			const devices = await api.moveDevice(node, destination, systemId);
			commit("devices/setDevices", devices, { root: true });
		},

		// NOTE: Unlike other provisioning related API endpoints, this does not
		//       automatically refresh the device tree, so the vuex store will
		//       be out of sync until the next time to device tree is refreshed
		async setPropertyProvision(__, { node, propName, propValue }) {
			const propType = _.get(node.description, [
				"meta",
				"properties",
				propName,
				"type",
			]);
			await api.setProperty(node.guid, propName, propValue, propType);
		},

		executeCommandProvision(_, __) {
			throw new Error("Command execution is only possible on a live K4 model");
		},
	},
};
